import React from 'react';
import { Button, defaultTheme } from '@amzn/storm-ui';
import styled from 'styled-components';
import { DetailAccountInfo, AccountType, multiCountryAccountType } from './Types';
import { AccountListItem } from './AccountListItem';
import { useAccountContext } from './AccountContextProvider';

const AccountList = styled.div`
  display: flex;
  flex-direction: column;
`;

const blue50 = defaultTheme.palette.blue[50];
const blue800 = defaultTheme.palette.blue[800];
const AccountListItemButton = styled(Button)<{
  isSelected: boolean;
}>`
  width: 100%;
  border-radius: 0px;
  padding: 8px 14px;
  &:hover {
    background: ${({ theme }) => theme.palette.gray[50]};
  }

  ${({ isSelected }) => {
    return isSelected && `
      background: ${blue50};
      border-inline-start: 3px solid ${blue800};
      &:hover {
        background: ${blue50};
      }
    `;
  }}
`;

type AccountListDesktopProps = {
  accounts: DetailAccountInfo[];
  accountType: AccountType;
  handleClick: (account: DetailAccountInfo) => void;
};

export const AccountListDesktop: React.VFC<AccountListDesktopProps> =
  ({accounts, accountType, handleClick}) => {
  const isMultiCountryAccountType = multiCountryAccountType.includes(accountType);
  const {
    selectedAccount,
    selectedAccountRef,
  } = useAccountContext();

  return (
    <AccountList>
      {accounts.map((account) => {
        const isSelected = account.entityId === selectedAccount?.entityId;
        return (
          <AccountListItemButton
            isSelected={isSelected}
            buttonRef={isSelected ? selectedAccountRef : null}
            key={account.entityId}
            transparent={true}
            onClick={() => handleClick(account)}
            data-takt-id={`interstitial-account-${account.entityId}-desktop`}
            data-testid={account.url}
          >
            <AccountListItem
            key={account.entityId}
            label={account.label}
            entityId={account.entityId}
            accountHasNestedAccounts={account.nestedAccounts ? account.nestedAccounts.length > 0 : false}
            isMultiCountryAccountType={isMultiCountryAccountType}
          />
          </AccountListItemButton>
        );
      })}
    </AccountList>
  );
}
